import { render, staticRenderFns } from "./CitySubView.vue?vue&type=template&id=21f188c2&scoped=true"
import script from "./CitySubView.vue?vue&type=script&lang=js"
export * from "./CitySubView.vue?vue&type=script&lang=js"
import style0 from "./CitySubView.vue?vue&type=style&index=0&id=21f188c2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f188c2",
  null
  
)

export default component.exports